import React from 'react';

function StatBox({ count, label, colorClass }) {
  return (
    <div className={`flex flex-col items-center px-6 py-4 rounded-lg ${colorClass}`}>
      <span className="text-3xl font-bold">{count}</span>
      <span className="text-sm mt-1">{label}</span>
    </div>
  );
}

export default function SyncSummaryModal({ summary, onClose }) {
  if (!summary) return null;

  return (
    /* Backdrop */
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
      <div className="bg-white rounded-2xl shadow-xl w-full max-w-md mx-4 p-8">
        {/* Header */}
        <div className="flex items-center gap-3 mb-6">
          <div className="bg-green-100 rounded-full p-2">
            <svg className="w-6 h-6 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                d="M5 13l4 4L19 7" />
            </svg>
          </div>
          <div>
            <h2 className="text-lg font-bold text-gray-900">Sync Complete</h2>
            <p className="text-sm text-gray-500">Greenbook data has been updated</p>
          </div>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-3 gap-3 mb-8">
          <StatBox
            count={summary.added}
            label="Added"
            colorClass="bg-green-50 text-green-700"
          />
          <StatBox
            count={summary.updated}
            label="Updated"
            colorClass="bg-blue-50 text-blue-700"
          />
          <StatBox
            count={summary.removed}
            label="Removed"
            colorClass="bg-orange-50 text-orange-700"
          />
        </div>

        {/* Close button */}
        <button
          onClick={onClose}
          className="w-full bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2.5 rounded-lg transition-colors"
        >
          Done
        </button>
      </div>
    </div>
  );
}
